import type { Theme } from '@src/app/themes';
import type { IconButtonProps } from '@src/shared/ui/Button';
import { IconButton } from '@src/shared/ui/Button';
import { forwardRef } from 'react';

const StyleShet = {
  button: (theme: Theme) => ({
    border: '1px solid',
    borderColor: theme.palette.grey[600],
    width: '40px',
    height: '40px',
    borderRadius: '4px',
  }),
};

const NavIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    const { children, ...rest } = props;
    return (
      <IconButton color="secondary" ref={ref} {...rest} sx={StyleShet.button}>
        {children}
      </IconButton>
    );
  },
);

export default NavIconButton;
